<template>
  <div class="aside-menu-container">
    <h4 class="aside-menu-heading">Tenant Portal</h4>
    <div class="aside-menu-list">
      <router-link to="/registrants" v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-item" :class="{ 'menu-item-active': isActive || isExactActive }">
          <span class="menu-icon-wrapper">
            <i class="flaticon2-sheet"></i>
          </span>
          <span class="menu-text">Pendaftar</span>
        </a>
      </router-link>

      <router-link to="/billings" v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-item" :class="{ 'menu-item-active': isActive || isExactActive }">
          <span class="menu-icon-wrapper">
            <i class="fas fa-file-invoice-dollar"></i>
          </span>
          <span class="menu-text">Billing</span>
        </a>
      </router-link>

      <router-link to="/tenants" v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-item" :class="{ 'menu-item-active': isActive || isExactActive }">
          <span class="menu-icon-wrapper">
            <i class="fas fa-network-wired"></i>
          </span>
          <span class="menu-text">Daftar Tenant</span>
        </a>
      </router-link>

      <router-link to="/databases" v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-item" :class="{ 'menu-item-active': isActive || isExactActive }">
          <span class="menu-icon-wrapper">
            <i class="fas fa-database"></i>
          </span>
          <span class="menu-text">Database</span>
        </a>
      </router-link>

      <router-link v-if="currentUser && currentUser.role_key_name === 'super_admin'" to="/product-control" v-slot="{ href, navigate, isActive, isExactActive }">
        <a :href="href" @click="navigate" class="menu-item" :class="{ 'menu-item-active': isActive || isExactActive }">
          <span class="menu-icon-wrapper"><i class="fas fa-box-open"></i></span>
          <span class="menu-text">Paket & Subscription</span>
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getUser } from "@/core/services/jwt.service.js";
export default {
  name: "RegistrantAside",
  data() {
    return { currentUser: getUser() };
  },
};
</script>

<style lang="scss" scoped>
.aside-menu-container {
  font-family: "Poppins", "Inter", sans-serif;
  padding: 10px 0;
}

.aside-menu-heading {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  letter-spacing: 0.1em;
  margin-bottom: 16px;
  padding-left: 12px;
}

.aside-menu-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 12px;
  color: #64748b !important;
  text-decoration: none !important;
  transition: all 0.25s ease;
  font-weight: 600;
  font-size: 13px;

  .menu-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: #f1f5f9;
    margin-right: 12px;
    transition: all 0.25s ease;

    i {
      font-size: 13px;
      color: #64748b;
      transition: all 0.25s ease;
    }
  }

  &:hover {
    background-color: #f8fafc;
    color: #1e293b !important;

    .menu-icon-wrapper {
      background-color: #e2e8f0;
      i {
        color: #1e293b;
      }
    }
  }

  &.menu-item-active {
    background: linear-gradient(135deg, rgba(20, 96, 143, 0.06), rgba(30, 149, 143, 0.1)) !important;
    color: #1e958f !important;

    .menu-icon-wrapper {
      background-color: rgba(30, 149, 143, 0.12) !important;
      i {
        color: #1e958f;
      }
    }
  }
}
</style>
